import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterDateBetween, FilterValue, FilterValueCollection } from '@hub/generated/models';
import { SearchController } from '@hub/generated/services';

@Component({
  selector: 'f-filterDate',
  templateUrl: './filterDate.component.html',
  styleUrls: ['./filterDate.component.scss']
})
export class FilterDateComponent implements OnInit {
  // Constructors
  constructor (private controller: SearchController) {
  }

    // Properties
  @Input()
  public filter: FilterDateBetween;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.date = this.setValue();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public date: Date;
  public columnName: string;

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.date = this.setValue();
  }

  public onChange() {
    let result: FilterValueCollection = new FilterValueCollection();
    result.List = [];

    result.ColumnName = this.columnName;
    if (this.date) {
      let value: FilterValue = { Key: '0', Value: this.date.toDateString(), EntityType: null };
      result.List.push(value);
    }

    if (!this.date) {
      result.List = [];
    }

    this.ondataChange.emit(result);
  }

  private setValue(): Date
  {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
      if (!!values && !!values.List && !!values.List.length) {
        let value = values.List[0];
        return new Date(value.Value);
      }
    }

    return null;
  }
}
